const iSharedDrivesConverter = (str, item) => {
  try {
    if ((item?.name === 'source_type' || item?.source_type === 'SHARED_DRIVE') && (str === 'Shared_drive' || str === 'SHARED_DRIVE')) {
      return this.$t('recovery.search.labels.sharedDrive')
    } else if (str === 'SHARED_DRIVE' || str === 'Shared_drive') {
      return this.$t('common.sharedDrives')
    }

    return str

  } catch (e) {
    return str
  }
}

const iSharedFoldersConverter = (str, item) => {
  try {
    if ((item?.name === 'source_type' || item?.source_type === 'SHARED_FOLDER') && (str === 'Shared_folder' || str === 'SHARED_FOLDER')) {
      return this.$t('seats.columns.tooltip.teamFolder')
    } else if (str === 'SHARED_FOLDER' || str === 'Shared_folder') {
      return this.$t('recovery.search.labels.teamFolders')
    }

    return str

  } catch (e) {
    return str
  }
}

export {
  iSharedDrivesConverter,
  iSharedFoldersConverter,
}
